import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
const navLinks = [{
  name: 'Programas',
  href: '#programas'
}, {
  name: 'Mentorías',
  href: '#mentorias'
}, {
  name: 'Alma',
  href: '#alma'
}, {
  name: 'Recursos',
  href: '#recursos'
}, {
  name: 'Comunidad',
  href: '#comunidad'
}, {
  name: 'Tienda',
  href: '#tienda'
}];
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (href: string) => {
    setIsMobileMenuOpen(false);
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <>
      <motion.nav initial={{
      y: -100
    }} animate={{
      y: 0
    }} transition={{
      duration: 0.6,
      ease: 'easeOut'
    }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-cream/95 backdrop-blur-md shadow-sm' : 'bg-transparent'}`} data-id="element-238">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-239">
          <div className="flex items-center justify-between h-20" data-id="element-240">
            <a href="#inicio" onClick={e => {
            e.preventDefault();
            scrollToSection('#inicio');
          }} className="font-serif text-2xl font-semibold text-charcoal tracking-wide" data-id="element-241">
              Daniel
            </a>

            <div className="hidden lg:flex items-center gap-8" data-id="element-242">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={e => {
              e.preventDefault();
              scrollToSection(link.href);
            }} className="text-sm font-sans text-charcoal-mid hover:text-charcoal transition-colors duration-300" data-id="element-243">
                  {link.name}
                </a>)}
              <a href="#mentorias" onClick={e => {
              e.preventDefault();
              scrollToSection('#mentorias');
            }} className="ml-4 px-6 py-2.5 bg-gold text-white text-sm font-medium rounded-full hover:bg-gold/90 transition-colors duration-300" data-id="element-244">
                Aplicar
              </a>
            </div>

            <button onClick={() => setIsMobileMenuOpen(true)} className="lg:hidden p-2 text-charcoal" aria-label="Abrir menú" data-id="element-245">
              <MenuIcon className="w-6 h-6" data-id="element-246" />
            </button>
          </div>
        </div>
      </motion.nav>

      <AnimatePresence data-id="element-247">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="fixed inset-0 z-50 lg:hidden" data-id="element-248">
            <div className="absolute inset-0 bg-charcoal/20 backdrop-blur-sm" onClick={() => setIsMobileMenuOpen(false)} data-id="element-249" />
            <motion.div initial={{
          x: '100%'
        }} animate={{
          x: 0
        }} exit={{
          x: '100%'
        }} transition={{
          duration: 0.4,
          ease: 'easeOut'
        }} className="absolute right-0 top-0 bottom-0 w-80 bg-cream shadow-2xl" data-id="element-250">
              <div className="p-6" data-id="element-251">
                <div className="flex items-center justify-between mb-12" data-id="element-252">
                  <span className="font-serif text-2xl font-semibold text-charcoal" data-id="element-253">
                    Daniel
                  </span>
                  <button onClick={() => setIsMobileMenuOpen(false)} className="p-2 text-charcoal" aria-label="Cerrar menú" data-id="element-254">
                    <XIcon className="w-6 h-6" data-id="element-255" />
                  </button>
                </div>
                <div className="flex flex-col gap-6" data-id="element-256">
                  {navLinks.map((link, index) => <motion.a key={link.name} href={link.href} onClick={e => {
                e.preventDefault();
                scrollToSection(link.href);
              }} initial={{
                opacity: 0,
                x: 20
              }} animate={{
                opacity: 1,
                x: 0
              }} transition={{
                delay: index * 0.1
              }} className="text-lg font-sans text-charcoal-mid hover:text-charcoal transition-colors" data-id="element-257">
                      {link.name}
                    </motion.a>)}
                  <motion.a href="#mentorias" onClick={e => {
                e.preventDefault();
                scrollToSection('#mentorias');
              }} initial={{
                opacity: 0,
                x: 20
              }} animate={{
                opacity: 1,
                x: 0
              }} transition={{
                delay: navLinks.length * 0.1
              }} className="mt-4 px-6 py-3 bg-gold text-white text-center font-medium rounded-full" data-id="element-258">
                    Aplicar
                  </motion.a>
                </div>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}